<template lang="pug">
    .slider-wrapper
        .wheels-slider
            .wheel-title {{activeSlide ? activeSlide.title : '16” легкосплавные диски Las Minas, черные'}}
            .button.prev(@click="onPrevClick")
            .slider-width
                swiper(:options="swiperOptions", ref="slider")
                    swiper-slide(v-for="(slide) in slides", :key="slide.id")
                        wheel-slide(:data="slide", @click="onSlideClick", :active="activeSlide === slide")
            .button.next(@click="onNextClick")
</template>
<script>
import WheelSlide from "./WheelsSlider/WheelSlide";
import {mapActions} from "vuex";
export default {
  name: 'WheelsSlider',
  components: {WheelSlide},
  props: ['slides', 'activeSlide'],
  data() {
    return {
      swiperOptions: {
        slidesPerView: 3,
        updateOnWindowResize: true,
      },
    }
  },

  computed: {
  },

  methods: {
    ...mapActions(['setCarWheels']),

    onSlideClick(data) {
      this.setCarWheels(data)
      this.$emit('selected', data)
    },

    onPrevClick() {
      this.$refs.slider.$swiper.slidePrev()
    },

    onNextClick() {
      this.$refs.slider.$swiper.slideNext()
    }
  }
}
</script>